"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forEachTransformDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var forEachTransformDependencies = exports.forEachTransformDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createForEachTransform: _factoriesAny.createForEachTransform
};